var _polygon, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyRoomSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.93,114.42C122.85,55,222,63.36,260.25,105.16s50.7,68.6,85.21,53,78.52-11.44,81,38.17S388.59,304.57,324.41,321.92s-64.16,78.76-149.1,66.37C129,381.54,128,331.43,134.49,290S62.55,183.36,94.93,114.42Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.93,114.42C122.85,55,222,63.36,260.25,105.16s50.7,68.6,85.21,53,78.52-11.44,81,38.17S388.59,304.57,324.41,321.92s-64.16,78.76-149.1,66.37C129,381.54,128,331.43,134.49,290S62.55,183.36,94.93,114.42Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-8",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 357.54,
    cy: 116.17,
    r: 17.82,
    transform: "translate(162.34 437.46) rotate(-76.72)",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.54,
    cy: 116.17,
    r: 15.15,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, 185.61, 450.49)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,117.36a1,1,0,0,1-.49-.13l-7-4a1,1,0,1,1,1-1.74l5.53,3.13v-8.88a1,1,0,1,1,2,0v10.59a1,1,0,0,1-.5.87A1,1,0,0,1,356.83,117.36Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.54,
    cy: 116.17,
    r: 17.82,
    transform: "translate(162.34 437.46) rotate(-76.72)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.89,386.39s1.54-11.27,8.75-12.51,5-6.68,6.91-8.79,6.78,4.11,2.58,10.14-.77,4.14-2.58,9.75S95.23,395.74,95.89,386.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.89,386.39s1.54-11.27,8.75-12.51,5-6.68,6.91-8.79,6.78,4.11,2.58,10.14-.77,4.14-2.58,9.75S95.23,395.74,95.89,386.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28,394.09l-.18,0a.51.51,0,0,1-.28-.65c0-.12,4.48-12,.18-30a77,77,0,0,0-5.59-15c-4.17-9-7.76-16.84-2.43-31.41,1.64-4.51,3.35-8.71,5-12.78,6.11-15,10.93-26.86,5.84-37.83a.52.52,0,0,1,.25-.67.5.5,0,0,1,.66.25c5.27,11.36.38,23.4-5.82,38.63-1.66,4.06-3.36,8.25-5,12.74-5.19,14.18-1.84,21.45,2.39,30.65A78.11,78.11,0,0,1,99,363.14c4.38,18.39-.17,30.51-.22,30.63A.51.51,0,0,1,98.28,394.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.35,391.46s4.66-7-2.07-10.64-8.07-.7-12.23-3.3-7.32-8.88-8-4.86,4.1,6.32,2.4,8.16S91.73,394.62,100.35,391.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72,271.8s3.43-14.12-6.89-13.59S98.89,270.71,103.72,271.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.63,283.09s-4.07-12.26-11.16-9S88.37,283.9,95.63,283.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.11,283.18s-1.9-9.9,5.84-10.72S118.94,280.69,108.11,283.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.59,304s9.66-10.11,14-3.5S111.36,309.42,104.59,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,303.78S82.86,288.53,74.84,294,78.85,305.91,86.05,303.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.42,326.43s5-16.06-6.43-13.38S72,323.31,80.42,326.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.56,330.57s8.81-12.25,16.55-9.21S117.67,336.29,98.56,330.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,356.69S82,338.94,75.11,345.74,81.05,360.85,91.76,356.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72,354.65s-3.33-14.12,5-13.62S115.54,350.43,103.72,354.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.72,271.8s3.43-14.12-6.89-13.59S98.89,270.71,103.72,271.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.63,283.09s-4.07-12.26-11.16-9S88.37,283.9,95.63,283.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.11,283.18s-1.9-9.9,5.84-10.72S118.94,280.69,108.11,283.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.59,304s9.66-10.11,14-3.5S111.36,309.42,104.59,304Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,303.78S82.86,288.53,74.84,294,78.85,305.91,86.05,303.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.42,326.43s5-16.06-6.43-13.38S72,323.31,80.42,326.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.56,330.57s8.81-12.25,16.55-9.21S117.67,336.29,98.56,330.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,356.69S82,338.94,75.11,345.74,81.05,360.85,91.76,356.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72,354.65s-3.33-14.12,5-13.62S115.54,350.43,103.72,354.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.74,291h-.1a.52.52,0,0,1-.32-.22c0-.08-4.59-7.31-7.7-8.86a.5.5,0,1,1,.44-.89c2.93,1.45,6.76,7.13,7.83,8.78,5.39-3.82,9.07-10.29,9.11-10.36a.49.49,0,0,1,.68-.19.51.51,0,0,1,.19.68c-.16.29-4,7.09-9.85,11A.54.54,0,0,1,100.74,291Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.84,310.88h-.06a.5.5,0,0,1-.35-.21c-.05-.08-5.63-7.92-12.23-11.13a.5.5,0,1,1,.44-.9c6,2.91,11,9.25,12.28,11,8.37-7.14,19.45-7.75,19.56-7.76a.48.48,0,0,1,.52.48.49.49,0,0,1-.47.52c-.11,0-11.22.62-19.36,7.87A.5.5,0,0,1,92.84,310.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.86,336.62a.46.46,0,0,1-.28-.08c-6.61-4.48-12.36-16.48-12.6-17a.5.5,0,0,1,.24-.67.51.51,0,0,1,.67.24c0,.12,5.7,11.91,12,16.4,1.94-1.31,12.81-8.4,21.52-9.27a.5.5,0,1,1,.1,1c-9.14.92-21.22,9.21-21.34,9.3A.54.54,0,0,1,88.86,336.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28,362.15a.52.52,0,0,1-.38-.17,27.42,27.42,0,0,0-14.39-7.8.5.5,0,1,1,.21-1A28.56,28.56,0,0,1,98.35,361c4.26-3.36,9.25-15.31,9.3-15.44a.5.5,0,0,1,.93.39c-.22.53-5.45,13-10,16.14A.51.51,0,0,1,98.28,362.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.63,389.78s4-6.36,8.51-7.26,6.46-6.11,8.13-3S113.34,393,99.63,389.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.37 414.75 76.74 414.75 73.82 387.83 123.29 387.83 120.37 414.75",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.31 392.93 72.8 392.93 72.14 387.23 124.97 387.23 124.31 392.93",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.31 392.93 72.8 392.93 72.14 387.23 124.97 387.23 124.31 392.93",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.97,
    y: 154.62,
    width: 120.74,
    height: 260.13,
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.97,
    y: 154.62,
    width: 116.89,
    height: 260.13,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.16,
    y: 169.23,
    width: 25.28,
    height: 98.69,
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.16,
    y: 169.23,
    width: 22.94,
    height: 98.69,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.94,295.57a4.39,4.39,0,1,1-4.39-4.39A4.38,4.38,0,0,1,319.94,295.57Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.94,
    cy: 295.57,
    r: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.94,
    cy: 295.57,
    r: 4.39,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257,237.37a75.09,75.09,0,0,1-9.09-5.19l-.87-7.85-.81-7.36c5.83,1.38,18.81,11.52,20.91,16C268.66,236.18,268.9,242.9,257,237.37Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.93,415h-8.27a.59.59,0,0,0-.58.47l-1.34,6.06a1,1,0,0,0,.78,1.19l.22,0c2.67,0,4.62-.21,8-.21,2.07,0,8.32.22,11.17.22s3.23-2.82,2.07-3.08c-5.25-1.15-9.2-2.73-10.88-4.24A1.66,1.66,0,0,0,218.93,415Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,414.78h-8.27a.6.6,0,0,0-.58.47l-1.34,6.06a1,1,0,0,0,.77,1.19.82.82,0,0,0,.22,0c2.68,0,4.63-.2,8-.2,2.07,0,8.31.21,11.17.21s3.23-2.82,2.06-3.08c-5.25-1.14-9.2-2.73-10.88-4.24A1.65,1.65,0,0,0,254,414.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.55,261.68h36.13c3.44,18.76,13.06,94.59,5.35,153.75l-12.24.38s2.27-89.87-8.53-118.9c-1.25,15.54-2.72,32.07-4,40.87-3.15,21.65-10.09,78-10.09,78H208.72s2.76-54.36,3.94-75.64C213.94,317.07,214.5,266.42,214.55,261.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72,415.81h12.45s6.94-56.39,10.09-78c1.28-8.79,2.75-25.32,4-40.86a97.49,97.49,0,0,1,4,15.63c6.45,34.83,4.49,103.27,4.49,103.27l12.23-.16c7.72-59.16-1.9-135.35-5.34-153.54H214.55c-.05,4.33-.6,55.18-1.89,78.28C211.48,361.67,208.72,415.81,208.72,415.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,296.91a97.49,97.49,0,0,1,4,15.63c1-13.82-3-28.49-3-28.49Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.68,262.11H214.55a175.76,175.76,0,0,0-1.66-21.58c-.55-3.91-1.29-8-2.27-12a74.58,74.58,0,0,0-2.69-8.76s16-6.55,38.31-2.78A252.47,252.47,0,0,1,250.68,262.11Z",
    style: {
      fill: "#006F95"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "225.43 266.14 247.98 266.15 247.64 261.71 225.43 261.98 225.43 266.14"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.1 266.15 251.48 266.15 250.68 261.68 248.75 261.7 249.1 266.15"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "224.31 262 214.55 262.11 214.55 266.14 224.31 266.14 224.31 262"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.76,261.41c-.28-.25-6.52-.16-7,.4,0,0-.24,4.24.05,4.61s6.27-.15,6.83-.17S241,261.66,240.76,261.41Zm-.69,4.43c-.47,0-5.37.44-5.61.13a20.26,20.26,0,0,1-.05-3.79c.38-.45,5.51-.53,5.74-.32S240.53,265.82,240.07,265.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67,263.09l-1.23,0a.45.45,0,0,0-.44.43v0a.45.45,0,0,0,.47.48l1.23-.05a.45.45,0,0,0,.43-.5A.46.46,0,0,0,239.67,263.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.89,240.53c-.55-3.91-1.29-8-2.27-12a6.15,6.15,0,0,1,1.45-.79S215.55,234.9,212.89,240.53Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.93,219.75c-7.37,3.5-17.42,25-15.37,32.28s20.1,17.82,20.1,17.82L207,275.33s4.57,3.88,6.63,3.43,4.42-5.48,4.27-8-3.3-4.62-3.3-4.62-12.82-13.7-13.08-16.87c-.63-7.63,9.33-20,9.33-20Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.93,219.75c-4.17.82-16.82,17.44-15.64,31l10.1-1.45s3-10.21,9.21-16.39c0,0,1.41-3.75-.39-9.81C210.54,220.82,207.93,219.75,207.93,219.75Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.59 250.21 203.07 248.75 203.07 250.21 191.59 252.95 191.59 250.21",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.59 250.21 203.07 248.75 203.07 250.21 191.59 252.95 191.59 250.21",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,237.37a75.09,75.09,0,0,1-9.09-5.19l-.87-7.85C249.13,225.47,256.83,230.2,257,237.37Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.18,229.66s-13.76-1.66-16.26-1.25-7.92,5.18-8.13,5.35,3.8,5.3,4.65,5.12,5.26-4.69,5.38-5.12.36-1.14.36-1.14l13.1,4.22S262.2,232.51,260.18,229.66Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.93,228.41a8.43,8.43,0,0,1,1.28,4.54l1.39,0a5.53,5.53,0,0,0,.31-4.41Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.93,228.41a8.43,8.43,0,0,1,1.28,4.54l1.39,0a5.53,5.53,0,0,0,.31-4.41Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.38,228.87c0,.51-.9.85-1.91.77s-1.81-.55-1.77-1,.89-.85,1.91-.77S248.42,228.37,248.38,228.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91,228.51c0,.37-.65.63-1.4.57s-1.33-.41-1.3-.78.66-.62,1.4-.56S247.94,228.14,247.91,228.51Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91,228.51c0,.37-.65.63-1.4.57s-1.33-.41-1.3-.78.66-.62,1.4-.56S247.94,228.14,247.91,228.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.95 237.41 260.62 228.84 261.98 229.36 261.51 238.38 258.95 237.41",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.95 237.41 260.62 228.84 261.98 229.36 261.51 238.38 258.95 237.41",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.19,219.75s1.5-3.81,8.69-5.06,15.08,2.05,17,4.45l-6.17.61-3.13,6.81-7.11-6.07Z",
    style: {
      fill: "#006F95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.19,219.75s1.5-3.81,8.69-5.06,15.08,2.05,17,4.45l-6.17.61-3.13,6.81-7.11-6.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.07,217.65c1.38,1.25,3.6,1.79,5.72,2l6.46,6,1.89-6.56s2.45-.87,1.38-2.46c-3-.49-4.43-1.89-5-3.67a8.53,8.53,0,0,1-.3-3.41,15.87,15.87,0,0,1,.25-1.91l-10.05-7.44C221.71,205.05,223.32,214.09,220.07,217.65Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.71,204.87c.4,6,5.35,7.69,7.78,8a8.53,8.53,0,0,1-.3-3.41Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.32,187.48s1.15,7.72-3.83,11.33-5-13.86-5-13.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,206.27a8.51,8.51,0,0,0,9.77,3.3,9.53,9.53,0,0,0,5.42-4.41q.24-.43.45-.9c2.45-5.74,3.23-15.77-2.83-19.52a9.23,9.23,0,0,0-12.72,2.89,9,9,0,0,0-1.38,4.06C220,198.39,219.25,202.3,222,206.27Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.52,195.27c-.13.53.11,1,.47,1.09s.72-.33.81-.87-.12-1-.47-1.09S230.62,194.73,230.52,195.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.64,196.32c-.13.53.12,1,.47,1.08s.72-.33.81-.87-.12-1-.47-1.09S236.73,195.8,236.64,196.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.65,196.25a19.37,19.37,0,0,0,1.79,5.07,3.18,3.18,0,0,1-2.68.05Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,193a.36.36,0,0,0,.33-.07,2.55,2.55,0,0,1,2.21-.72.32.32,0,0,0,.39-.24.31.31,0,0,0-.23-.38h0a3.18,3.18,0,0,0-2.8.86.33.33,0,0,0,0,.46h0A.38.38,0,0,0,229,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,201.5h0a5,5,0,0,1,3.92,2.34.18.18,0,0,1-.07.23.15.15,0,0,1-.22-.06h0a4.73,4.73,0,0,0-3.65-2.15.17.17,0,0,1-.16-.17v0a.17.17,0,0,1,.17-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.63,194.66a.28.28,0,0,0,.18,0,.33.33,0,0,0,.23-.39h0a3.18,3.18,0,0,0-2-2.18.32.32,0,0,0-.4.22h0a.33.33,0,0,0,.22.4h0a2.58,2.58,0,0,1,1.54,1.75A.35.35,0,0,0,239.63,194.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.66,180.92c-.8-.11-1.6-.2-2.4-.24a12,12,0,0,0-6.72,1.34c-4.63,2.75-3.83,9.78-3.23,14.34.79,6.06,3.17,8.8,3.17,8.8-1.44-2.89-1-8.52-.07-8.66s.87.94.87.94c2.09-1.3,4-5,3.32-7.58-.5-2,1.73-3.46,3.6-2.53l.57.28.89.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.91,196.65a6.39,6.39,0,0,0,3.08,3.81c2,1.07,3.46-.59,3.33-2.72-.14-1.89-1.31-4.78-3.51-5A2.87,2.87,0,0,0,216.91,196.65Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.34,186.68c-.44.77.66,3.25-1.83,2.66s-2.66.46-4.42,2.17-5.34-.89-5.34-.89l-3.9.51s-2.86-2.56-1.07-3.94,2.18-3.34,3.27-5.65,5.95-5.31,11.1-1.8c0,0,2.74-.94,3.95-.26a7.32,7.32,0,0,1,2.17,2.49,1.84,1.84,0,0,1,2.78-.09c1.4,1.46.29,6.68,1.49,8s-1.49,2.93-1.49,2.93-2.11-.5-2.11-2.05c0-2.74-.4-3.72-1.74-4.22a1.25,1.25,0,0,0-1.4.43S234,185.46,233.34,186.68Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRoomSchedule);
export default __webpack_public_path__ + "static/media/empty-room-schedule.5be712ff6af23510aa836d76e6a2d78e.svg";
export { ForwardRef as ReactComponent };